"use strict";
// disable patching requestAnimationFrame
window.__Zone_disable_requestAnimationFrame = true;
// disable patching specified eventNames
window['__zone_symbol__PASSIVE_EVENTS'] = ['scroll'];
window.__zone_symbol__UNPATCHED_EVENTS = ['message'];
